import { connect } from 'react-redux';
import { withProps, compose } from 'react-recompose';
import PickNumber from './PickNumber';
import { setPickedPhoneNumber } from '../../../../modules/SignUp/PhoneNumber';
import {
  fetchAvailablePhoneNumbers,
  setCurrentPhoneNumber,
  phoneNumbersSelector,
  currentPhoneNumberSelector,
} from '../../../../modules/SignUp/AvailablePhoneNumbers';
import { isLoadingSelector } from '../../../../modules/LoadingStatus';
import config from '../../../../config';
import type { FlaggedProps } from './PickNumber';

const mapStateToProps = state => {
  const selectedNumber = currentPhoneNumberSelector(state);
  return {
    numbers: phoneNumbersSelector(state),
    selectedNumber: selectedNumber ? selectedNumber : '',
    isFetching: isLoadingSelector(state, 'getAvailablePhoneNumbers'),
  };
};

const mapDispatchToProps = {
  getAvailablePhoneNumbers: fetchAvailablePhoneNumbers,
  selectNumber: setCurrentPhoneNumber,
  setPickedPhoneNumber,
};

const withFlaggedProps = (): FlaggedProps => ({
  canSelectPreferredNumbers: config.canSelectPreferredNumbers,
});

export default compose(connect(mapStateToProps, mapDispatchToProps), withProps(withFlaggedProps))(PickNumber);
